export const APP_CONSTANTS = {
  TXN_STATUS_CLS: {
    TXN_REFUND: 'bg-secondary',
    TXN_FAILURE: 'bg-danger',
    TXN_PENDING:'bg-warning text-dark',
    TXN_SUCCESS:'bg-success',
    TXN_ABORT:'bg-success',
    TXN_EXPIRED:'bg-danger',
    TXN_CANCELLED:'bg-warning text-dark',
    TXN_AUTHORIZED:'bg-warning text-dark',
    BOOKED_AND_INPROGRESS:'bg-warning text-dark',
    NO_RECORDS_FOUND:'bg-danger'
  },
  TICKET_STATUS_CLS: {
    'Open': 'bg-warning text-dark',
    'In Progress': 'bg-secondary',
    'Closed':'bg-success text-light',
    'Reopened':'bg-warning text-dark',
    'Cancelled':'bg-danger'
  },
  TICKET_NEXT_ACTION:{
    'OPEN': {Value:'Closed', Text:'Close Ticket', Theme:'warning'},
    'CLOSED': {Value:'Reopened', Text:'Reopen Ticket', Theme:'danger'},
    'REOPENED': {Value:'Closed', Text:'Close Ticket', Theme:'warning'}
  },
  ENTITY_TYPE_KEY:{
    1:'um',
    2:'um',
    3:'sh',
    4:'um',
    5:'um',
    6:'sm',
    7:'um'
  },
  PENDING_ACTION_CLS: {
    Pending: 'warning',   
    Completed:'success',
    Available:'success',
    Unavailable:'warning',
    लंबित:'warning',
    पूर्ण:'success',
    अनुपलब्ध:'warning',
    उपलब्ध:'success'
  },
} ;

export const APP_CONFIG = {
  API_URL: 'https://example.com',
  VERSION: '21.0.0',
  MAX_PAGE_SIZE: 20
};

